export default "__VITE_ASSET__680b1a28__"